<div class="pagination-container">
    <div class="pagination-info">
        <span *ngIf="total > 0" class="item-count"> {{ startItem }} - {{ endItem }} of {{ total }} items </span>
        <span *ngIf="total === 0" class="item-count"> 0 items </span>
    </div>

    <div class="pagination-controls">
        <button
            type="button"
            class="pagination-btn"
            [disabled]="!hasPreviousPage || disabled"
            (click)="onPreviousPage()"
            aria-label="Previous page"
        >
            <span class="material-symbols-rounded">chevron_left</span>
        </button>

        <div class="page-display">
            <span class="page-info"> Page {{ currentPage }} of {{ totalPages }} </span>
        </div>

        <button
            type="button"
            class="pagination-btn"
            [disabled]="!hasNextPage || disabled"
            (click)="onNextPage()"
            aria-label="Next page"
        >
            <span class="material-symbols-rounded">chevron_right</span>
        </button>

        <div class="page-size-selector">
            <select
                #pageSizeSelect
                [ngModel]="pageSize"
                (ngModelChange)="onPageSizeChange($event)"
                [disabled]="disabled"
                aria-label="Items per page"
            >
                <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} per page</option>
                <option [ngValue]="selectAllValue">All ({{ total }} items)</option>
            </select>
        </div>
    </div>
</div>
